__turbopack_context__.v({
  "className": "mattermedium_4406aecf-module__PH2MUW__className",
  "variable": "mattermedium_4406aecf-module__PH2MUW__variable",
});
